import React from "react";
import "./HomeSec1.css";

export default function HomeSec1({ currentLanguage = "en" }) {
  const translations = {
    en: {
      leftLines: [
        {
          text: "WITH EVERY CLIENT",
          highlight: "EVERY GOAL,"
        },
        {
          text: "TRANSPARENCY STAYS OUR",
          highlight: "GUIDING ROLE,"
        },
        {
          text: "TURNING VISION INTO",
          highlight: "FINANCIAL SOUL."
        }
      ],
      cards: [
        {
          value: "500+",
          label: "Clients Served"
        },
        {
          value: "20+",
          label: "Years Experience"
        }
      ]
    },

    fr: {
      leftLines: [
        {
          text: "AVEC CHAQUE CLIENT",
          highlight: "CHAQUE OBJECTIF,"
        },
        {
          text: "LA TRANSPARENCE RESTE",
          highlight: "NOTRE GUIDE,"
        },
        {
          text: "TRANSFORMER LA VISION EN",
          highlight: "ÂME FINANCIÈRE."
        }
      ],
      cards: [
        {
          value: "500+",
          label: "Clients Servis"
        },
        {
          value: "20+",
          label: "Années d’Expérience"
        }
      ]
    }
  };

  const homeSec1Data = translations[currentLanguage] || translations.en;

  return (
    <section id="next-section" className="home1-wrapper section">
      <div className="row align-items-center">
        
        {/* LEFT TEXT */}
        <div className="col-12 col-md-6 mb-4 mb-md-0">
          <div className="home1-text">
            {homeSec1Data.leftLines.map((line, index) => (
              <h4 className="line" key={index}>
                {line.text} <span>{line.highlight}</span>
              </h4>
            ))}
          </div>
        </div>

        {/* RIGHT CARDS */}
        <div className="col-12 col-md-6">
          <div className="row g-3 justify-content-center">
            {homeSec1Data.cards.map((card, index) => (
              <div className="col-6" key={index}>
                <div className="home1-card">
                  <h2 className="value">{card.value}</h2>
                  <p>{card.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
